import { render, staticRenderFns } from "./BaTradersList.vue?vue&type=template&id=413a46b6&"
import script from "./BaTradersList.vue?vue&type=script&lang=js&"
export * from "./BaTradersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports